import marketModalFactory, { TagName } from './index';
export default marketModalFactory(TagName.MarketModalFull);